/**
 * Channel tab — customer acquisition channel breakdown (RCP vs walk-in vs kiosk).
 */

import { KpiTile } from '@/components/primitives';
import type { RrmFilters } from './types';

export interface ChannelTabProps {
  filters: RrmFilters;
}

export function ChannelTab({ filters: _filters }: ChannelTabProps): JSX.Element {
  return (
    <>
      <div className="rrm-kpi-strip">
        <KpiTile label="RCP (self-service)" value="42%" severity="approvals" delta={{ dir: 'up', text: '6pp MoM' }} />
        <KpiTile label="RAE (booking-driven)" value="27%" severity="balance" delta={{ dir: 'up', text: '4pp MoM' }} />
        <KpiTile label="Walk-in (in-person)" value="31%" delta={{ dir: 'down', text: '10pp MoM' }} />
        <KpiTile label="Kiosk (future)" value="0%" />
      </div>

      <article className="rrm-chart-card">
        <header className="rrm-chart-header">
          <div>
            <div className="rrm-chart-title">Channel-mix trend</div>
            <div className="rrm-chart-sub">% of opened accounts by originating channel · 12 months</div>
          </div>
        </header>
        <div className="rrm-chart-body">
          <svg viewBox="0 0 620 280" width="100%" height={280} role="img" aria-label="Stacked area chart — channel mix over 12 months">
            <line x1={30} y1={30} x2={600} y2={30} stroke="var(--ink-200)" />
            <line x1={30} y1={90} x2={600} y2={90} stroke="var(--ink-200)" />
            <line x1={30} y1={150} x2={600} y2={150} stroke="var(--ink-200)" />
            <line x1={30} y1={210} x2={600} y2={210} stroke="var(--ink-200)" />
            <text x={25} y={34} textAnchor="end" fontSize={10} fill="var(--ink-500)">100%</text>
            <text x={25} y={94} textAnchor="end" fontSize={10} fill="var(--ink-500)">75%</text>
            <text x={25} y={154} textAnchor="end" fontSize={10} fill="var(--ink-500)">50%</text>
            <text x={25} y={214} textAnchor="end" fontSize={10} fill="var(--ink-500)">25%</text>

            <polygon points="50,210 95,205 140,200 185,195 230,190 275,188 320,180 365,170 410,160 455,155 500,148 545,140 590,130 590,210" fill="var(--ent-loan)" opacity={0.85} />
            <polygon points="50,180 95,175 140,168 185,162 230,158 275,150 320,142 365,138 410,130 455,125 500,118 545,110 590,100 590,130 545,140 500,148 455,155 410,160 365,170 320,180 275,188 230,190 185,195 140,200 95,205 50,210" fill="var(--ent-deposit)" opacity={0.85} />
            <polygon points="50,145 95,140 140,135 185,125 230,115 275,105 320,95 365,85 410,75 455,65 500,55 545,48 590,40 590,100 545,110 500,118 455,125 410,130 365,138 320,142 275,150 230,158 185,162 140,168 95,175 50,180" fill="var(--ent-application)" opacity={0.85} />

            {['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'].map((m, i) => (
              <text key={m} x={50 + i * 45} y={230} textAnchor="middle" fontSize={10} fill={m === 'Apr' ? 'var(--pcb-blue-dark)' : 'var(--ink-600)'} fontWeight={m === 'Apr' ? 700 : 400}>{m}</text>
            ))}

            <rect x={50} y={252} width={12} height={12} fill="var(--ent-application)" />
            <text x={68} y={262} fontSize={11} fill="var(--ink-600)">Self-service (RAO) · 42%</text>
            <rect x={230} y={252} width={12} height={12} fill="var(--ent-deposit)" />
            <text x={248} y={262} fontSize={11} fill="var(--ink-600)">Appointment-driven (RAE) · 27%</text>
            <rect x={460} y={252} width={12} height={12} fill="var(--ent-loan)" />
            <text x={478} y={262} fontSize={11} fill="var(--ink-600)">In-person walk-in · 31%</text>
          </svg>
        </div>
      </article>
    </>
  );
}
